<template>
  <div class="base-fill-up">
    <BlockUI v-if="busy">
      <div class="loader"></div>
    </BlockUI>
    <div v-if="posPage.step === getStepPage.STEP_FULL_FILLUP" class="create-order-inter">
        <groupSender    :errorshow="errorshow"
                        :basefillupSetting="basefillupSetting" 
                        :inputSenderValidation="$v.inputSender" 
                        :countries="countries"
                        @pageStepBack="pageStepBack" 
                        :inputSender="inputSender" />
        <groupRecipient :selectedCourier="selectedCourier"
                        :disableSelectedCountry="disableSelectedCountry"
                        :countries="countries"
                        :errorshow="errorshow"
                        :basefillupSetting="basefillupSetting" 
                        :inputRecipientValidation="$v.inputRecipient" 
                        :inputRecipient="inputRecipient" />
        <groupParcel @busyHandle="busyHandle" 
                    :editInter="editInter" 
                    :parcelValidation="$v.parcel"
                    :parcel="parcel"
                    :errorshow="errorshow"  
                    :country="country" 
                    :inputParcelValidation="$v.inputParcel.$each" 
                    :countries="countries" 
                    :shop_id="shop_id" 
                    :selectedCourier="selectedCourier" 
                    :listSize="listSize" 
                    @removeParcel="removeParcel" 
                    :inputParcel="inputParcel"
                    @addParcel="addParcel" />
        <div class="group-remark-base-fillup">
            <div class="form-group">
                <label>หมายเหตุ</label>
                <textarea class="form-control" v-model="parcel.remarkOrderDetail" rows="3"
                  maxlength="100"
                  placeholder="optional (ไม่จำเป็น)">
                  </textarea>
                <span class="remark-length">{{ parcel.remarkOrderDetail.length }} / 100</span>
            </div>
        </div>
        <div class="group-summit d-flex justify-content-end">
            <b-button variant="primary" @click="pageStepCourier">
                เลือกขนส่ง
            </b-button>
        </div>
    </div>
    <div v-if="posPage.step === getStepPage.STEP_SELECT_COURIER_INTER" class="select-order-inter">
        <SelectCourierInter @pageStepBack="pageStepBack" :courierList="courierList" :isSelected="isSelected" />
        <div class="d-flex px-5 py-3 justify-content-between background-color-table mt-3">
            <b-button class="m-0 mr-2 px-5" variant="primary" @click="changestepPage(getStepPage.STEP_FULL_FILLUP)">
                ย้อนกลับ
            </b-button>
            <b-button class="m-0 px-5" variant="success" @click="editInter.status === false ? assignToCart() : editItem()">
                ยืนยัน
            </b-button>
        </div>
        
    </div>
  </div>
</template>

<script>
import { 
    getStepPage
} from "@/plugins/posHelper.js";
import SelectCourierInter from '@/components/PosFullFillup/SelectCourierInter.vue'
import groupSender from '@/components/PosFullFillup/groupSender.vue'
import groupParcel from '@/components/PosFullFillup/groupParcel.vue'
import groupRecipient from '@/components/PosFullFillup/groupRecipient.vue'
import { required } from 'vuelidate/lib/validators';
export default {
    components: {
        groupSender,
        groupParcel,
        groupRecipient,
        SelectCourierInter
    },
    props: {
        editInter: {
            type: [Object, Array]
        },
        count: {
            type: [Number]
        },
        checkDisableCardCourier: {
            type: [Function]
        },
        cart: {
            type: [Object, Array]
        },
        busy: Boolean,
        shop_id: {
            type: [String, Number]
        },
        posPage: {
            type: Object
        },
        selectedCourier: {
            type: [Object, String]
        },
        sender: {
            type: Object
        },
        listSize: {
            type: [Object, Array]
        },
        basefillupSetting: {
            type: Object
        }
    },
    data() {
        return {
            isSelected:{
                courierIndex: null,
                list: [],
                errorShow: false,
                delivery_selected: 'pick_up'
            },
            courierList: [],
            getStepPage: getStepPage,
            errorshow: {
                parcel: {
                    sumWeight: false,
                },
                inputRecipient: {
                    company: {
                        language: false,
                    },
                    name: {
                        language: false,
                    },
                    address: {
                        language: false,
                    },
                    address2: {
                        language: false,
                    },
                    state: {
                        language: false,
                    },
                    city: {
                        language: false,
                    },
                },
                inputSender: {
                    company: {
                        language: false,
                    },
                    name: {
                        language: false,
                    },
                    address: {
                        language: false,
                    },
                    address2: {
                        language: false,
                    },
                    province: {
                        language: false,
                    },
                    district: {
                        language: false,
                    },
                    subdistrict: {
                        language: false,
                    },
                }
            },
            countries: [],
            inputParcel: [
                {
                    type_parcel: {
                        id: null,
                        text: null,
                        text_only_en: null,
                        text_only_th: null
                    },
                    overall_price: "",
                    count_parcel: "",
                    weight: "",
                    country_parcel: {
                        text: '',
                        alpha_2_code: '',
                        alpha_3_code: '',
                        calling_code: '',
                        destination_supported: '',
                        id: '',
                        manufacturer_supported: '',
                    },
                    hscode: ""
                }
            ],
            inputSender: {
                selectedPhoneCountry: {
                    showInput: '',
                    text: '',
                    alpha_2_code: '',
                    alpha_3_code: '',
                    calling_code: '',
                    destination_supported: '',
                    id: '',
                    manufacturer_supported: '',
                },
                company: "",
                taxId: "",
                name: "",
                tel: "",
                address: "",
                address2: "",
                province: "",
                district: "",
                subdistrict: "",
                postcode: "",
                id_no: "",
                birthday: "",
            },
            inputRecipient: {
                selectedPhoneCountry: {
                    showInput: '',
                    text: '',
                    alpha_2_code: '',
                    alpha_3_code: '',
                    calling_code: '',
                    destination_supported: '',
                    id: '',
                    manufacturer_supported: '',
                },
                company: "",
                taxId: "",
                name: "",
                tel: "",
                address: "",
                address2: "",
                country: {
                    text: '',
                    alpha_2_code: '',
                    alpha_3_code: '',
                    calling_code: '',
                    destination_supported: '',
                    id: '',
                    manufacturer_supported: '',
                },
                state: "",
                city: "",
                postcode: ""
            },
            country: [
                {
                    value: null,
                    text: '----- กรุณาเลือกประเทศ -----'
                }
            ],
            disableSelectedCountry: false,
            parcel: {
                remarkOrderDetail: "",
                size: {
                    boxSize: ''
                },
                weight: '',
                weightKG: '',
                width: '',
                length: '',
                height: '',
                key_size: '',
            }
        }
    },
    // {
    //                     id: null,
    //                     text: null
    //                 }
    validations: {
        inputParcel: {
              $each: {
                type_parcel: { 
                    id: {
                        required 
                    },
                    text: {
                        required
                    }
                },
                overall_price: { required },
                count_parcel: { required },
                weight: { required },
                country_parcel: { 
                    id: {
                        required 
                    }
                }
              }
        },
        inputSender: {
            selectedPhoneCountry: {
                alpha_2_code: {
                    required
                }
            },
            name: { required },
            tel: {
                required
            },
            address: {
                required
            },
            province: {
                required
            },
            district: {
                required
            },
            subdistrict: {
                required
            },
            postcode: {
                required
            },
        },
        inputRecipient: {
            selectedPhoneCountry: {
                alpha_2_code: {
                    required
                }
            },
            name: { required },
            tel: { required },
            address: { required },
            country: { 
                text: { required }
            },
            state: { required },
            city: { required },
            postcode: { required }
        },
        parcel: {
            size: {
                boxSize: { }
            },
            weight: { required },
            width: { required },
            height: { required },
            length: { required }
        }
    },
    computed: {

    },
    methods: {
        busyHandle(boolean) {
            this.busy = boolean;
        },
        async setupVariableEdit(item, check) {
            // console.log('doing again lor kub ', item, check)
            this.inputParcel = item.item
            this.inputSender = item.from
            this.inputRecipient = item.to
            this.parcel = item.parcel
            this.editInter.status = true
            this.editInter.check = check
        },
        editItem() {
            if (this.isSelected.courierIndex === null) {
                this.isSelected.errorShow = true
                return false
            }
            const tempCart = JSON.parse(JSON.stringify(this.cart))
            const indexOfCart = tempCart.findIndex((res) => res.check === this.editInter.check);
            
            const bodyJson = {
                check: this.count++,
                type: "ship",
                sender: this.sender,
                from: this.inputSender,
                to: this.inputRecipient,
                parcel: this.parcel,
                courier: this.isSelected.list,
                item: this.inputParcel,
                dropoff_type:  this.selectedCourier.key === 'INT' ? "INTER_BOOK" : this.selectedCourier.key === 'LAO' ? "LAO_BOOK" : null,
                refer_id: this.isSelected.list.id,
                num: 1,
                price: this.isSelected.list.sum_price_shop,
                courier_name: this.isSelected.list.name,
                name: this.isSelected.list.name,
                error: {
                    data: [],
                    msg: null,
                    status: false
                },
                service_price_inter: this.isSelected.list.service_shop,
                key: tempCart[indexOfCart].key,
                weight: this.parcel.weight,
                height: this.parcel.height,
                length: this.parcel.length,
                width: this.parcel.width,
                delivery_selected: this.isSelected.delivery_selected
            }
            if(bodyJson.dropoff_type === null) {
                console.error('เกิดข้อผิดพลาดขึ้นบางอย่าง dropoff_type ไม่มีข้อมูล')
                return false
            }
            const check = this.editInter.check
            this.editInter.status = false
            const indexOfCartItem = this.cart.findIndex((res) => res.check === check);
            if (indexOfCartItem !== -1) {
              this.cart.splice(indexOfCartItem, 1);
              this.cart.push(bodyJson);
            }
            
            this.$emit('addCartToLocalStorage')
            this.$emit('checkDisableCardCourier')
            // if(tempCart.length < this.cart.length) {
            this.posPage.step = getStepPage.STEP_PAGE_FIRST
            this.clearIsSelected()
        },
        clearIsSelected() {
            this.isSelected = {
                courierIndex: null,
                list: [],
                errorShow: false,
                delivery_selected: 'pick_up'
            }
        },
        assignToCart() {
            if (this.isSelected.courierIndex === null) {
                this.isSelected.errorShow = true
                return false
            }
            // check จะมีปัญหาตอน ลบออเดอร์แล้ว กลับ มาเพิ่มเลข บวกต่อไม่ได้ อยากลบไอ check ออกจากชีวิต ไปเลยได้ไหม 
            // มันควรจะทำไรบ้างกระทบอะไรบ้าง
            const bodyJson = {
                check: this.count++,
                type: "ship",
                sender: this.sender,
                from: this.inputSender,
                to: this.inputRecipient,
                parcel: this.parcel,
                courier: this.isSelected.list,
                refer_id: this.isSelected.list.id,
                item: this.inputParcel,
                dropoff_type:  this.selectedCourier.key === 'INT' ? "INTER_BOOK" : this.selectedCourier.key === 'LAO' ? "LAO_BOOK" : null,
                num: 1,
                price: this.isSelected.list.sum_price_shop,
                courier_name: this.isSelected.list.name,
                name: this.isSelected.list.name,
                error: {
                    data: [],
                    msg: null,
                    status: false
                },
                service_price_inter: this.isSelected.list.service_shop,
                key: this.selectedCourier.key,
                weight: this.parcel.weight,
                height: this.parcel.height,
                length: this.parcel.length,
                width: this.parcel.width,
                delivery_selected: this.isSelected.delivery_selected
            }
            if(bodyJson.dropoff_type === null) {
                console.error('เกิดข้อผิดพลาดขึ้นบางอย่าง dropoff_type ไม่มีข้อมูล')
                return false
            }
            this.cart.push(bodyJson)
            this.$emit('addCartToLocalStorage')
            this.$emit('checkDisableCardCourier')
            this.posPage.step = getStepPage.STEP_PAGE_FIRST
            this.isSelected = {
                courierIndex: null,
                list: [],
                errorShow: false,
            }
        },
        generatePriceAndCourierInter() {
            this.busy = true
            const idCountry = this.inputRecipient.country.id
            const countries = this.countries.find(res => idCountry === res.id)
            const tempParcel = JSON.parse(JSON.stringify(this.parcel))
            const bodyJson = {
                weight: parseFloat(tempParcel.weight),
                height: parseFloat(tempParcel.height),
                length: parseFloat(tempParcel.length),
                width: parseFloat(tempParcel.width),
                country_code: countries.alpha_2_code,
                show_all: true
            }

            const headers = {
                headers: {
                    token: localStorage.getItem('access_token')
                }
            }

            this.$http.post(this.$API_URL + '/inter/checkprice/courier', bodyJson, headers).then((res) => {
                this.courierList = res.data.data
            }).finally(() => {
                this.busy = false
                console.log('this.parcel: ', this.parcel)
            })
        },
        changestepPage(key) {
            console.log('before change this.parcel: ', this.parcel)
            this.courierList = []
            this.isSelected = {
                courierIndex: null,
                list: [],
                errorShow: false,
            }
            this.posPage.step = key
            console.log('after change this.parcel: ', this.parcel)
        },
        validateInputParcel() {
            this.$v.inputParcel.$touch();
            this.$emit('validate-parcel', this.$v.inputParcel.$invalid);
        },
        validateParcel(index) {
            return this.$v.inputParcel[index].$touch();
        },
        conditionValidation() {

        },
        pageStepCourier() {
            const { $v: { inputSender, inputRecipient, inputParcel, parcel } } = this;
            inputSender.$touch()
            inputRecipient.$touch()
            inputParcel.$touch()
            parcel.$touch()
            this.cleanErrorShow()
            this.clearIsSelected()

            if(this.basefillupSetting.typeFillup !== 'DEFAULT') {
                const languageError = this.validationLanguage()
                if(!languageError.status) {
                    return false
                }
            }
            let sum_weight_parcel = 0
            this.inputParcel.map((res) => {
                sum_weight_parcel =  sum_weight_parcel + parseInt(res.weight)
            })
            if (parseInt(this.parcel.weight) < sum_weight_parcel) {
                this.errorshow.parcel.sumWeight = true;
                return false
            }
            if(inputSender.$invalid || inputRecipient.$invalid || inputParcel.$invalid || parcel.$invalid) {
                return false
            }

            this.posPage.step = getStepPage.STEP_SELECT_COURIER_INTER
            this.generatePriceAndCourierInter()
        },
        validationLanguage() {
              const languageValidationRegex = this.basefillupSetting.typeFillup === 'ENGLISH'
                ? /^[A-Za-z\s0-9]+$/
                : /^[ก-๙\s0-9]+$/

              const fieldsSenderValidate = ['name', 'company', 'address', 'address2', 'province', 'district', 'subdistrict']
              const fieldsRecipientValidate = ['name', 'address', 'address2', 'company', 'state', 'city']

              fieldsSenderValidate.forEach((field) => {
                if (field === 'address' || field === 'address2') {
                  const addressValidationRegex = this.basefillupSetting.typeFillup === 'ENGLISH'
                    ? /^[0-9A-Za-z!@#$%^&*()-_=+{}[\]|;:'",.<>/?~`\s]+$/
                    : /^[0-9\Wก-๙!@#$%^&*()-_=+{}[\]|;:'",.<>/?~`\s]+$/
                    if(this.inputSender[field] != "") {
                        if (!addressValidationRegex.test(this.inputSender[field])) {
                            this.errorshow.inputSender[field].language = true
                        }
                    }
                } else if (field === 'company') {
                    if(this.inputSender[field] !== '') {
                        const languageValidationCompany = this.basefillupSetting.typeFillup === 'ENGLISH'
                        ? /^[0-9A-Za-z!@#$%^&*()-_=+{}[\]|;:'",.<>/?~`\s]+$/
                        : /^[0-9\Wก-๙!@#$%^&*()-_=+{}[\]|;:'",.<>/?~`\s]+$/
                        if (!languageValidationCompany.test(this.inputSender[field])) {
                            this.errorshow.inputSender[field].language = true
                        }
                    }else {
                        this.errorshow.inputSender[field].language = false
                    }
                } else {
                  if (!languageValidationRegex.test(this.inputSender[field])) {
                    this.errorshow.inputSender[field].language = true
                  }
                }
              })
          
              fieldsRecipientValidate.forEach((field) => {
                if (field === 'address' || field === 'address2') {
                  const addressValidationRegex = this.basefillupSetting.typeFillup === 'ENGLISH'
                    ? /^[0-9A-Za-z!@#$%^&*()-_=+{}[\]|;:'",.<>/?~`\s]+$/
                    : /^[0-9\Wก-๙!@#$%^&*()-_=+{}[\]|;:'",.<>/?~`\s]+$/
                    if(this.inputRecipient[field] != "") {
                        if (!addressValidationRegex.test(this.inputRecipient[field])) {
                        this.errorshow.inputRecipient[field].language = true
                      }
                    }
                } else if (field === 'company') {
                    if(this.inputRecipient[field] !== '') {
                        const languageValidationCompany = this.basefillupSetting.typeFillup === 'ENGLISH'
                        ? /^[0-9A-Za-z!@#$%^&*()-_=+{}[\]|;:'",.<>/?~`\s]+$/
                        : /^[0-9\Wก-๙!@#$%^&*()-_=+{}[\]|;:'",.<>/?~`\s]+$/
                        if (!languageValidationCompany.test(this.inputRecipient[field])) {
                            this.errorshow.inputRecipient[field].language = true
                        }
                    }else {
                        this.errorshow.inputRecipient[field].language = false
                    }
                } else {
                  if (!languageValidationRegex.test(this.inputRecipient[field])) {
                    this.errorshow.inputRecipient[field].language = true
                  }
                }
                if(this.inputRecipient[field] === "") {
                    this.errorshow.inputRecipient[field].language = false
                }
              })

              const hasValidationSender = fieldsSenderValidate.some((field) => {
                return this.errorshow.inputSender[field].language === true;
              });

              const hasValidationRecipient = fieldsRecipientValidate.some((field) => {
                return this.errorshow.inputRecipient[field].language === true;
              });
        
              return {
                status: (!hasValidationRecipient && !hasValidationSender)
              };
            },
        async getAllCountry() {
            this.busy = true
            const headers = {
                headers: {
                    token: localStorage.getItem('access_token')
                }
            }
            await this.$http.get(this.$API_URL + '/inter/all/country', headers).then(async (res) => {
                this.countries = res.data.data.countries
                await this.mapCountry()
            }).finally(async () => {
                this.busy = false
            })
        },
        isCourier(key) {
            return this.selectedCourier.key === key ? true : false
        },
        async pageStepBack() {
            this.clearParcelAll()
            this.cleanErrorShow()
            await this.clearSender()
            await this.clearRecipient()
            // await this.clearEditInter()
            
            this.posPage.step = getStepPage.STEP_PAGE_FIRST
            return this.$emit('clearEditInter')
        },
        addParcel() {
            const newParcel =  {
                    type_parcel: {
                        id: null,
                        text: null,
                        text_only_en: null,
                        text_only_th: null
                    },
                    overall_price: "",
                    count_parcel: "",
                    weight: "",
                    country_parcel: {
                        text: '',
                        alpha_2_code: '',
                        alpha_3_code: '',
                        calling_code: '',
                        destination_supported: '',
                        id: '',
                        manufacturer_supported: '',
                    },
                    hscode: ""
                }
            this.inputParcel.push(newParcel);
        },
        removeParcel(index) {
            this.inputParcel.splice(index, 1);
        },
        cleanErrorShow() {
            this.errorshow = {
                parcel: {
                    sumWeight: false,
                },
                inputRecipient: {
                    company: {
                        language: false,
                    },
                    name: {
                        language: false,
                    },
                    address: {
                        language: false,
                    },
                    address2: {
                        language: false,
                    },
                    state: {
                        language: false,
                    },
                    city: {
                        language: false,
                    },
                },
                inputSender: {
                    company: {
                        language: false,
                    },
                    name: {
                        language: false,
                    },
                    address: {
                        language: false,
                    },
                    address2: {
                        language: false,
                    },
                    province: {
                        language: false,
                    },
                    district: {
                        language: false,
                    },
                    subdistrict: {
                        language: false,
                    },
                }
            }
        },
        clearParcelAll() {
            this.inputParcel = [
                {
                    type_parcel: {
                        id: null,
                        text: null,
                        text_only_en: null,
                        text_only_th: null
                    },
                    overall_price: "",
                    count_parcel: "",
                    weight: "",
                    country_parcel: {
                        text: '',
                        alpha_2_code: '',
                        alpha_3_code: '',
                        calling_code: '',
                        destination_supported: '',
                        id: '',
                        manufacturer_supported: '',
                    },
                    hscode: ""
                }
            ]
            this.errorshow.parcel.sum_weight = false
        },
        clearSender() {
            this.inputSender = {
                selectedPhoneCountry: {
                    showInput: '',
                    text: '',
                    alpha_2_code: '',
                    alpha_3_code: '',
                    calling_code: '',
                    destination_supported: '',
                    id: '',
                    manufacturer_supported: '',
                },
                company: "",
                taxId: "",
                name: "",
                tel: "",
                address: "",
                address2: "",
                province: "",
                district: "",
                subdistrict: "",
                postcode: "",
                id_no: "",
                birthday: "",
            }
        },
        clearRecipient() {
            this.inputRecipient = {
                selectedPhoneCountry: {
                    showInput: '',
                    text: '',
                    alpha_2_code: '',
                    alpha_3_code: '',
                    calling_code: '',
                    destination_supported: '',
                    id: '',
                    manufacturer_supported: '',
                },
                name: "",
                tel: "",
                address: "",
                country: {
                    text: '',
                    alpha_2_code: '',
                    alpha_3_code: '',
                    calling_code: '',
                    destination_supported: '',
                    id: '',
                    manufacturer_supported: '',
                },
                address2: "",
                company: "",
                taxId: "",
                state: "",
                city: "",
                postcode: ""
            }
        },
        async setUpThailandSender() {
            const event = await this.countries.find(res => {
                if(res.alpha_2_code === 'TH') {
                    return res
                }                
            })
            this.inputSender.selectedPhoneCountry.showInput = '+'+ event.calling_code + ' '+ event.text
            this.inputSender.selectedPhoneCountry.text = event.text
            this.inputSender.selectedPhoneCountry.alpha_2_code = event.alpha_2_code
            this.inputSender.selectedPhoneCountry.alpha_3_code = event.alpha_3_code
            this.inputSender.selectedPhoneCountry.calling_code = event.calling_code
            this.inputSender.selectedPhoneCountry.destination_supported = event.destination_supported
            this.inputSender.selectedPhoneCountry.id = event.id
            this.inputSender.selectedPhoneCountry.manufacturer_supported = event.manufacturer_supported
        },
        bindingData(key) {
            if(key === 'sender') {
                this.inputSender.name = this.sender.name
                this.inputSender.tel = this.sender.tel
                this.inputSender.address = this.sender.address
                this.inputSender.province = this.sender.province
                this.inputSender.district = this.sender.district
                this.inputSender.subdistrict = this.sender.state
                this.inputSender.id_no = this.sender.id_no
                this.inputSender.birthday = this.sender.birthday
                this.inputSender.postcode = this.sender.postcode
                this.setUpThailandSender()
            }else if(key === 'sender:tel') {
                this.inputSender.tel = this.sender.tel
                this.setUpThailandSender()    
            }
        },
        settingCountryLAO() {
            const LAOCountry = this.countries.find(res => res.alpha_3_code === "LAO")
            // country
            this.inputRecipient.country = {}
            this.inputRecipient.country.text = LAOCountry.text
            this.inputRecipient.country.alpha_2_code = LAOCountry.alpha_2_code
            this.inputRecipient.country.alpha_3_code = LAOCountry.alpha_3_code
            this.inputRecipient.country.calling_code = LAOCountry.calling_code
            this.inputRecipient.country.destination_supported = LAOCountry.destination_supported
            this.inputRecipient.country.id = LAOCountry.id
            this.inputRecipient.country.manufacturer_supported = LAOCountry.manufacturer_supported


            // phone 
            this.inputRecipient.selectedPhoneCountry.showInput = '+' + LAOCountry.calling_code + ' '+ LAOCountry.text
            this.inputRecipient.selectedPhoneCountry.text = LAOCountry.text
            this.inputRecipient.selectedPhoneCountry.alpha_2_code = LAOCountry.alpha_2_code
            this.inputRecipient.selectedPhoneCountry.alpha_3_code = LAOCountry.alpha_3_code
            this.inputRecipient.selectedPhoneCountry.calling_code = LAOCountry.calling_code
            this.inputRecipient.selectedPhoneCountry.destination_supported = LAOCountry.destination_supported
            this.inputRecipient.selectedPhoneCountry.id = LAOCountry.id
            this.inputRecipient.selectedPhoneCountry.manufacturer_supported = LAOCountry.manufacturer_supported
        },
        lockSelectedCountry() {
            this.disableSelectedCountry = true
        },
        separateCourier() {
            if( this.isCourier('INT') ) {
                this.bindingData('sender:tel')
            }else if ( this.isCourier('LAO') ) {
                this.bindingData('sender')
                this.settingCountryLAO()
                this.lockSelectedCountry()
            }
        },
        mapCountry() {
            this.countries.map((res) => {
                const ObjectValue = {
                    value: res.id,
                    text: res.text
                }
                this.country.push(ObjectValue)
            })
        },
        setUpEdit() {
            // if(this.editInter.status) {
                console.log('doing la naja')
                this.inputParcel = this.editInter.item.item
                this.inputSender = this.editInter.item.from
                this.inputRecipient = this.editInter.item.to
                this.parcel = this.editInter.item.parcel
                if(this.selectedCourier.key === 'LAO') {
                    this.lockSelectedCountry()
                }
            // }
        }
    },
    async mounted() {
        await this.getAllCountry()
        if(this.editInter.status) {
            // this.inputParcel = this.editInter.item.item
            // this.inputSender = this.editInter.item.from
            // this.inputRecipient = this.editInter.item.to
            // this.parcel = this.editInter.item.parcel
            // if(this.selectedCourier.key === 'LAO') {
            //     this.lockSelectedCountry()
            // }
            this.setUpEdit()
        }else {
            console.log('selectedCourier: ', this.selectedCourier)
            await this.separateCourier()
        }

    }
}
</script>